export function getWorkerUrl(name: string) {
  // NOTE: worker can not use publicPath because it must obey the same-origin policy
  //
  // `subPath` has no trailing slash ('/mindmap'), so it must be joined with an
  // explicit one. Upstream concatenated `(subPath || '/') + 'js/'`, which only
  // works when subPath is empty — with a subpath set it produced '/mindmapjs/'
  // and the worker failed to load, leaving the app stuck on its loading skeleton.
  const base = environment.subPath || '';
  return `${base}/js/${name}-${BUILD_CONFIG.appVersion}.worker.js`;
}
